import {useContext} from 'react';
import {ModalContext} from "../context/ModalContext.tsx";


export const useModal = () => {
    return useContext(ModalContext);
};
